import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../../../utils/utils';
import { editOffersStatus, getOffers } from '../../../../../../crud/offer.crud';

export const useAccept = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingAccept, setLoading] = useState(false);
  const [successAccept, setSuccess] = useState(false);

  const fetchAcceptIds = useCallback(
    async (data: { ids: string; status: 'moderation' | 'active' | 'deleted' }) => {
      setLoading(true);
      editOffersStatus(data)
        .then(() => {
          setSuccess(true);
          enqueueSnackbar(`${intl.formatMessage({ id: 'STATUS.SUCCESS.CHANGE' })}`, {
            variant: 'success',
          });
        })
        .catch(e => {
          enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
            variant: 'error',
          });
        })
        .finally(() => {
          setTimeout(() => {
            setSuccess(false);
          }, 200);
          setLoading(false);
        });
    },
    []
  );

  const fetchAcceptList = useCallback(
    async (data: {
      company_id?: number;
      product_id?: number;
      status?: 'moderation' | 'active' | 'deleted';
      new_status?: 'moderation' | 'active' | 'deleted';
      page?: number;
      per_page?: number;
    }) => {
      setLoading(true);
      getOffers(data)
        .then(() => {
          setSuccess(true);
          enqueueSnackbar(`${intl.formatMessage({ id: 'STATUS.SUCCESS.CHANGE' })}`, {
            variant: 'success',
          });
        })
        .catch(e => {
          enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
            variant: 'error',
          });
        })
        .finally(() => {
          setTimeout(() => {
            setSuccess(false);
          }, 200);
          setLoading(false);
        });
    },
    []
  );

  return { fetchAcceptIds, fetchAcceptList, loadingAccept, successAccept };
};
